export interface ApiErrorBody {
    status?: number;
    code?: string;
    message?: string;
    [key: string]: any;
}

/**
 * What the API said when a request failed. Public requests (useApi) throw the
 * fetch Response itself; guarded ones (sendAuthGuardedRequest) throw an Error
 * carrying `status` and the parsed `body`. Both come back as one shape.
 */
export async function readApiError(e: any): Promise<ApiErrorBody> {
    if (!e) return {};
    if (typeof Response !== 'undefined' && e instanceof Response) {
        let body: any = {};
        try {
            body = await e.clone().json();
        } catch {
            // not JSON: the status is all there is
        }
        return { ...(body && typeof body === 'object' ? body : {}), status: e.status };
    }
    if (e.body && typeof e.body === 'object') return { ...e.body, status: e.status ?? e.body.statusCode };
    return { status: e.status, message: e.message };
}
